module.exports = __webpack_public_path__ + "static/media/parlament.9f6a78f9.jpg";